import React, { FC } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useFetchOrganization } from 'services/organization'
import { Menu } from './components/Menu'
import { Settings } from './Settings'
//import { LegalDocuments } from './LegalDocuments'
import styles from './Organization.module.scss'

export const Organization: FC = () => {
  const { organization } = useFetchOrganization()

  if (!organization) return null

  return (
    <div className={styles.organization}>
      <Menu />
      <div className={styles.content}>
        <Routes>
          <Route path="/settings" element={<Settings organization={organization} />} />
          {/*<Route path="/legal-documents/*" element={<LegalDocuments />} /> */}
        </Routes>
      </div>
    </div>
  )
}

Organization.displayName = 'Organization'
